import {ISquad} from "data/types/entities";

export abstract class SquadUtils {
	static getAbbreviation(squad?: ISquad) {
		return squad?.abbreviation ?? "";
	}
}
